
namespace Matrix.Workflow {

    @Serenity.Decorators.registerEditor('Matrix.Workflow.WorkflowInstanceDocumentGrid')
    @Serenity.Decorators.element("<div/>")
    export class WorkflowInstanceDocumentGrid extends SiteEntityGrid<WorkflowInstanceDocumentRow, any> {
        protected getColumnsKey() { return 'Workflow.WorkflowInstanceDocument'; }
        protected getDialogType() { return WorkflowInstanceDocumentDialog; }
        protected getIdProperty() { return WorkflowInstanceDocumentRow.idProperty; }
        protected getLocalTextPrefix() { return WorkflowInstanceDocumentRow.localTextPrefix; }
        protected getService() { return WorkflowInstanceDocumentService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getInitialTitle() {
            return null;
        }

        protected getAddButtonCaption() {
            return "New Document";
        }

        protected usePager() {
            return false;
        }

        protected addButtonClick() {
            if (!this.workflowInstanceId) {
                Q.notifyError("Please save the workflow instance first!");
                return;
            }

            this.editItem(<WorkflowInstanceDocumentRow>{
                WorkflowInstanceId: this.workflowInstanceId,
                DocumentGroup: "upload"
            });
        }

        private _workflowInstanceId: number;

        get workflowInstanceId() {
            return this._workflowInstanceId;
        }

        set workflowInstanceId(value: number) {
            if (this._workflowInstanceId !== value) {
                this._workflowInstanceId = value;
                this.setEquality(WorkflowInstanceRow.Fields.WorkflowInstanceId, value);
                this.refresh();
            }
        }

        protected getGridCanLoad() {
            return super.getGridCanLoad() && !!this._workflowInstanceId;
        }

        protected getColumns() {
            var columns = super.getColumns();

            var injectIndex = Q.indexOf(columns, x => x.field ==
                WorkflowInstanceDocumentRow.Fields.DocumentName) + 1;

            columns.splice(injectIndex, 0,
                {
                    width: 32,
                    minWidth: 32,
                    maxWidth: 32,
                    field: 'Download',
                    name: '',
                    format: ctx => {
                        return '<a class="inline-action download-file" title="download"><i class="fa fa-download text-purple"></i></a>';
                    },
                    sortable: false,
                    headerFilterType: Serenity.HeaderFilterType.disabled
                });

            //columns.splice(injectIndex + 1, 0,
            //    {
            //        width: 32,
            //        minWidth: 32,
            //        maxWidth: 32,
            //        field: 'View',
            //        name: '',
            //        format: ctx => {
            //            return '<a class="inline-action view-file" title="view"><i class="fa fa-search text-maroon"></i></a>';
            //        },
            //        sortable: false,
            //        headerFilterType: Serenity.HeaderFilterType.disabled
            //    });

            return columns;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);

            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row) as WorkflowInstanceDocumentRow;
            var target = $(e.target);

            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (!target.hasClass('inline-action'))
                return;

            e.preventDefault();

            if (target.hasClass('download-file') ||
                target.hasClass('view-file')) {
                WorkflowInstanceDocumentService.Retrieve({
                    EntityId: item.WorkflowInstanceDocumentId,
                    ColumnSelection: Serenity.RetrieveColumnSelection.keyOnly,
                    IncludeColumns: [
                        WorkflowInstanceDocumentRow.Fields.DocumentContent,
                        WorkflowInstanceDocumentRow.Fields.DocumentType,
                        WorkflowInstanceDocumentRow.Fields.DocumentName
                    ]
                }, response => {
                        downloadBase64Content(response.Entity.DocumentContent as any,
                            response.Entity.DocumentName, response.Entity.DocumentType, target.hasClass('view-file'));
                });
            }
        }
    }

    export function downloadBase64Content(base64Data: string, fileName: string,
        mimeType?: string, view?: boolean) {
        mimeType = mimeType || 'octet/stream';
        if (view) {
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                var blob = base64toBlob(base64Data, mimeType);
                window.navigator.msSaveOrOpenBlob(blob, fileName);
            } else { // Directly use base 64 encoded data for rest browsers (not IE)
                var dataURI = "data:" + mimeType + ";base64," + base64Data;
                window.open(dataURI, '_blank');
            }
        }
        else {
            var blob = base64toBlob(base64Data, mimeType);
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style.display = "none";
            var url = window.URL.createObjectURL(blob);
            a.href = url;
            if (!view)
                a.download = fileName;
            a.click();
            window.setTimeout(() => window.URL.revokeObjectURL(url), 0);
        }
    }

    export function base64toBlob(base64Data: string, contentType = '', sliceSize = 512) {
        const byteCharacters = atob(base64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }
}